export default __webpack_public_path__ + "static/media/baner3.8d20e8f1.png";